<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-13 09:57:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-09-19 10:10:09
-->
<template>
  <div id="box" class="box">
    <div id="left" :style="{height:`${heightLeft}px`}" class="left">
      <div style="font-weight:600;" class="title">组织机构</div>
      <div class="search">
        <a-input-search
          v-model:value="value"
          placeholder="搜索组织名称"
          size="large"
        >
          <template #enterButton>
            <img @click="search" class="img" src="@/assets/images/search.jpg" />
          </template>
        </a-input-search>
      </div>
       <a-spin :spinning="treeLoading">
      <div class="ant-tree">
        <a-tree
          ref="tree"
          :style="{height:`${heightLeft-100}px`,overflowY:'auto',overflowX:'hidden'}"
          show-line
          :tree-data="treeData"
          v-if="treeData.length > 0"
          @select="onSelect"
          :auto-expand-parent="isCloseAll"
          :defaultExpandedKeys="defaultExpandedKeys"
          :selectedKeys="checkedKeys"
          :expanded-keys="expandedKeys"
          :default-expanded-keys="columnOpenIds"
          @expand="onExpand"
        >
          <template  slot-scope="text" slot="child">
               <a-icon   class="icon-box-img"  type="link" />
           </template>
  	     
        </a-tree>
      </div>
      </a-spin>
    </div>
     <div id="resize" :style="{height:`${heightLeft}px`}"></div>
    <div id="right" class="right">
      <div class="right-title-box">
           <div style="font-weight: 600;" class="right-name">已采纳稿件列表-{{ organizationName }}</div>
      </div>
      <div class="right-flex">
        <a-dropdown>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item v-if="codeData.indexOf('374') != -1" key="1">
              批量删除</a-menu-item
            >
          </a-menu>
          <a-button
            class="btn-p"
            style="margin-left: 8px;margin-bottom:20px"
          >
            批量操作 <a-icon type="down" />
          </a-button>
        </a-dropdown>
        <div class="search">
           
                 <a-range-picker  style="margin-right:8px;max-width:350px" showTime v-model="timeTwo" format="YYYY-MM-DD HH:mm:ss"/>
          <a-input
            v-model:value="valueName"
            placeholder="按标题搜索"
            style="max-width:173px;"
          />
            <el-button class="search-box" type="primary"  @click="listSearch"
          ></span>查询</el-button
        >
        </div>
      </div>
      <coententTable
        :y="height"
        @onShowSizeChange="onShowSizeChange"
        :columns="columns"
        :dataSource="dataSource"
        :customSlot="customSlot"
        :isSelectRow="isSelectRow"
        @selectedRowKeys="selectedRowKeys"
        @handleSizeChange="handleSizeChange"
        :loading="loading"
        :rowKeys="rowKeys"
      >
        <template v-slot:titleTwo="scopeVal">
            <div @click="toPathUrl(scopeVal.scope)" v-if="scopeVal.scope.type==1" class="title-box"><span :title="scopeVal.scope.title">{{scopeVal.scope.title}}</span></div>
            <div style="cursor: pointer;" @click="chaKan(scopeVal.scope)" v-else ><span :title="scopeVal.scope.title">{{scopeVal.scope.title}}</span></div>
        </template> 
         <template v-slot:adoptType="scopeVal">
            {{scopeVal.scope.adoptType == 1 ? '原文采纳':scopeVal.scope.adoptType == 2?'修改采纳':scopeVal.scope.adoptType == 3?'不采纳':'—'}}
        </template>
        <template v-slot:stateRizhi="scopeVal">
           <a v-if="codeData.indexOf('381') != -1" @click="see(scopeVal.scope)"
              >查看</a
            >
        </template>
        <template v-slot:operation="scopeVal">
           <div style="display: flex">
               <div
            class="btnTwo"
            style="margin-right:14px;" v-if="codeData.indexOf('372') != -1" @click="updateAdop(scopeVal.scope)" >修改评分</div
          >
          <div
            class="btnTwo"
            @click="toPath(scopeVal.scope)"
            v-if="scopeVal.scope.adoptType != 1 && codeData.indexOf('406') != -1"
             style="margin-right:14px"
            >编辑稿件</div
          >
           <!-- <div
            class="btnFour"
            v-if="scopeVal.scope.adoptType == 1 && codeData.indexOf('406') != -1"
             style="margin-right:14px"
            >编辑稿件</div
          > -->
          <el-popover
            placement="left"
             style="margin-right:14px"
            v-if="scopeVal.scope.adoptType == 1 && codeData.indexOf('406') != -1"
            trigger="hover"
            content="原文采纳稿件应由创作人员所属组织进行编辑">
            <el-button  class="btnFour" slot="reference">编辑稿件</el-button>
          </el-popover>
           <div
            @click="noAdoption(scopeVal.scope)"
            v-if="codeData.indexOf('374') != -1"
            class="btnThree">
            删除
          </div>
           </div>
          
        </template>
      </coententTable>
      <div id="pagination" class="pagination">
        <a-pagination
          :current="pagination.current"
          :pageSize="pagination.pageSize"
          show-size-changer
          show-quick-jumper
          :total="pagination.total"
          @change="onShowSizeChange"
          @showSizeChange="handleSizeChange"
          :page-size-options="pagination.pageSizeOptions"
          :show-total="(total) => `共 ${pagination.total} 条`"
        />
      </div>
    </div>
    <el-dialog
            title="删除已采纳稿件？"
            :visible.sync="dialogVisibleTwo"
            width="450px"
            class="tips-box"
            top="17%"
          >
            <span>删除后，该稿件所属组织的对应评分将一并被删除，原文采纳和修改采纳的稿件不受影响，若需删除稿件，请至栏目稿件页面进行处理。</span>
            <span slot="footer" class="dialog-footer">
              <el-button size="small" @click="dialogVisibleTwo = false">取消</el-button>
              <el-button size="small" :loading="deleteShow" type="danger" @click="deleteOne()">确认删除</el-button>
            </span>
    </el-dialog>
    <el-dialog
            title="修改评分"
            :visible.sync="updateAdoptionShow"
            width="535px"
            class="tips-box"
            top="17%"
          >
          <div class="title-adoptin">
          <i class="el-icon-info icon-title"></i>
          <div>
          <div> 将按照修改后的评分进行统计</div>
          </div>
      </div>
      <a-spin :spinning="loadingScore">
           <el-checkbox-group class="score-box" v-model="checkedCities">
                <el-checkbox class="item"  v-for="item in arrayData" :label="item.id" :key="item.id">
                  <div class="item-txt">{{item.name}}</div>
                </el-checkbox>
              </el-checkbox-group>
      </a-spin>
       <span slot="footer" class="dialog-footer">
              <el-button size="small" @click="()=>{
                      this.checkedCities = [];
                      this.updateAdoptionShow = false;
                
                }">取消</el-button>
              <el-button v-if="codeData.indexOf('373') != -1" size="small" :disabled="loadingScore" :loading="updateShow" type="primary" @click="updateScore">确认修改</el-button>
            </span>
    </el-dialog>
     <See :item="itemData" @closeTwo="closeTwo" :visible="visible"></See>
      <Tips :item="itemData"  @onClose="onCloseTips" @close="onCloseTips" :visible="visibleAddTips"/>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import Tips from '../ManuscriptSubmitted/tips.vue'
import {
  tree,
  acceptListPage,
  adoptRemove,
  detailsSelectPage,
  pushScoringList,
  updateScoring
} from "./index";
import See from "@/components/more_information.vue";
export default {
  data() {
    return {
      value: "",
      valueName: "",
      visible:false,
      visibleAddTips:false,
      updateAdoptionShow:false,
      height: 0,
      heightLeft: 0,
      isCloseAll: false,
      checkedSiteIdTwo: [],
      selectedKeys: [],
      treeData: [],
      resData: [],
      timeTwo: [],
      columns: [
        {
          title: "标题",
          dataIndex: "title",
          ellipsis: true,
          scopedSlots: { customRender: "titleTwo" },
          customCell: (column) => {
            return {
              style: {
                "min-width": "320px",
                "max-width": "500px",
              },
            };
          },
          customHeaderCell: (column) => {
            return {
              style: {
                "min-width": "320px",
                "max-width": "500px",
              },
            };
          },
        },
        {
          title: "采纳方式",
          dataIndex: "adoptType",
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: "adoptType" },
        },
        {
          title: "加分组织",
          dataIndex: "organName",
          ellipsis: true,
          width: 200,
        },
         {
          title: "采纳人",
          dataIndex: "adoptName",
          ellipsis: true,
          width: 200,
        },
         {
          title: "采纳时间",
          dataIndex: "adoptTime",
          ellipsis: true,
          width: 200,
        },
        {
          title: "更多信息",
          dataIndex: "stateRizhi",
          scopedSlots: { customRender: "stateRizhi" },
          width: 120,
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 260,
          fixed: "right",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      organizationId: "",
      customSlot: [
        {
          name: "stateRizhi",
          customRender: "stateRizhi",
        },
        {
          name: "adoptType",
          customRender: "adoptType",
        },
        {
          name: "titleTwo",
          customRender: "titleTwo",
        },
      ],
      organizationName: "",
      isSelectRow: true,
      rowKeys: [],
      loading: false,
      time: "",
      selectDatas: [],
      checkedKeys: [],
      codeData: [],
      columnOpenIds: [],
      dialogVisibleTwo: false,
      deleteShow: false,
      defaultExpandedKeys: [],
      treeLoading: false,
      oldThreeData: [],
      expandedKeys: [],
      arrayData:[],
      checkedCities:[6,8],
      itemData:{},
      isMore:false,
      updateShow:false,
      loadingScore:false,
    };
  },
  components: {
    coententTable,
    See,
    Tips
  },
  watch: {
    value(val) {
      this.search();
    },
  },
  mounted() {
    this.getThreeList();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
    this.heightLeft = `${document.documentElement.clientHeight - 200}`;
    this.getLeftMove();
    this.$nextTick(() => {
      var left = document.getElementById("left");
      var box = document.getElementById("box");
      var right = document.getElementById("right");
      var pagination = document.getElementById("pagination");
      left.style.width = 250 + "px";
      right.style.width = box.clientWidth - 250 - 5 + "px";
      if (box.clientWidth - 250 - 5 < 1000) {
        document.getElementsByClassName(
          "ant-pagination"
        )[0].style.marginRight = 0;
        document.getElementsByClassName(
          "ant-pagination-options"
        )[0].style.display = "none";
      } else {
        document.getElementsByClassName("ant-pagination")[0].style.marginRight =
          "124px";
        document.getElementsByClassName(
          "ant-pagination-options"
        )[0].style.display = "block";
      }
      pagination.style.width = box.clientWidth - 250 + 5 + "px";
    });
  },
  methods: {
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.isCloseAll = false;
    },
     toPathUrl(item) {
      window.open(item.viewUrl);
    },
     onCloseTips(){
       this.visibleAddTips = false;
    },
    filterTree(arr, keyword, first = true) {
      console.log(arr, keyword);
      if (first) {
        //首次传入深度克隆数据防止修改源数据
        arr = JSON.parse(JSON.stringify(arr));
      }
      let emptyArr = [];
      for (let item of arr) {
        if (item.title.includes(keyword)) {
          // if (item.children &&Array.isArray(item.children)&& item.children.length > 0) {
          //     item.children = this.filterTree(item.children, keyword,false);
          // }
          emptyArr.push(item);
          this.expandedKeys.push(item.key);
        } else if (
          item.children &&
          Array.isArray(item.children) &&
          item.children.length > 0
        ) {
          item.children = this.filterTree(item.children, keyword, false);
          if (item.children.length) {
            emptyArr.push(item);
            this.expandedKeys.push(item.key);
          }
        }
      }
      return emptyArr;
    },
     updateAdop(item){
        this.loadingScore = true;
        this.itemData = item;
        let _this = this;
        this.updateAdoptionShow = true;
        detailsSelectPage({
          current:1,
          size:1000000,
        }).then((res)=>{
            if(res.code == 0){
                _this.arrayData = res.data.records;
                pushScoringList({
                   id:_this.itemData.id,
                }).then((resTwo)=>{
                    if(resTwo.code == 0){
                       let arrayCheck = [];
                       if(resTwo.data && resTwo.data.length > 0){
                          for (let index = 0; index < resTwo.data.length; index++) {
                          const element = resTwo.data[index];
                          arrayCheck.push(element.scoringId)
                        }
                       }
                        _this.checkedCities = JSON.parse(JSON.stringify(arrayCheck));
                        _this.loadingScore = false;
                    }
                })
            } 
        })
    },
    getLeftMove() {
      var resize = document.getElementById("resize");
      var left = document.getElementById("left");
      var right = document.getElementById("right");
      var box = document.getElementById("box");
      var pagination = document.getElementById("pagination");
      let _this = this;
      resize.onmousedown = function (e) {
        var startX = e.clientX;
        resize.left = resize.offsetLeft;
        document.onmousemove = function (e) {
          var endX = e.clientX;

          var moveLen = resize.left + (endX - startX);
          var maxT = box.clientWidth - resize.offsetWidth;
          if (moveLen < 250) moveLen = 250;
          if (moveLen > 600) moveLen = 600;
          if (moveLen > maxT - 150) moveLen = maxT - 150;

          resize.style.left = moveLen;
          left.style.width = moveLen + "px";
          right.style.width = box.clientWidth - moveLen - 5 + "px";
          if (box.clientWidth - moveLen - 5 < 1000) {
            _this.height = document.documentElement.clientHeight - 500;
            document.getElementsByClassName(
              "ant-pagination"
            )[0].style.marginRight = 0;
            document.getElementsByClassName(
              "ant-pagination-options"
            )[0].style.display = "none";
          } else {
            _this.height = document.documentElement.clientHeight - 480;
            document.getElementsByClassName(
              "ant-pagination"
            )[0].style.marginRight = "124px";
            document.getElementsByClassName(
              "ant-pagination-options"
            )[0].style.display = "block";
          }
          pagination.style.width = box.clientWidth - moveLen + 5 + "px";
        };
        document.onmouseup = function (evt) {
          document.onmousemove = null;
          document.onmouseup = null;
          resize.releaseCapture && resize.releaseCapture();
        };
        resize.setCapture && resize.setCapture();
        return false;
      };
    },
    search() {
      if (!this.value) {
        this.treeData = this.oldThreeData;
        return;
      }
      let newData = JSON.parse(JSON.stringify(this.treeData));
      this.treeData = this.filterTree(newData, this.value);
      this.isCloseAll = true;
    },
     closeTwo(){
      this.visible = false;
    },
     see(item) {
       this.itemData = item;
       this.visible = true;
    },
      handleMenuClick(e) {
       if (this.rowKeys.length == 0) {
        this.$message.error("请选择操作项");
        return false;
      }
      this.dialogVisibleTwo = true;
      this.isMore = false;
    },
    listSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    toPath(item){
        if(item.newManuscriptId){
            let routeData =  this.$router.resolve({
            path: "/index/content/manuscripts_edit",
            query: {
              id:item.newManuscriptId,
              title: "编辑稿件",
              islast: true,
            },
          });
          window.open(routeData.href, '_blank');
        }else{
           let routeData = this.$router.resolve({
              path: "/index/content/manuscripts_edit",
              query: {
                id: item.id,
                title: "编辑稿件",
                islast: true,
                isModify: true,
                scoreIds: '',
              },
            });
            window.open(routeData.href, "_blank");
        }
    },
    deleteOne() {
      this.deleteShow = true;
      let array = [];
      if(this.isMore){
          array = [this.itemData.id]
      }else{
        array = this.rowKeys;
      }
      adoptRemove({
        idList:array,
      }).then((res) => {
        if (res) {
          if (res.code == 0) {
            this.deleteShow = false;
            this.dialogVisibleTwo = false;
            this.rowKeys = [];
            this.getList();
          }
        }
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(page, pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
    updateScore(){
      this.updateShow = true;
      updateScoring({
        id:this.itemData.id,
        scoringCriteria:this.checkedCities.join(',')
      }).then((res)=>{
          if(res.code == 0){
                this.updateAdoptionShow = false;
                this.getList();
          }
           this.updateShow = false;
      })
    },
    selectedRowKeys(keys, selectedRows) {
      this.rowKeys = keys;
      this.selectDatas.push(...selectedRows);
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
     getList() {
      this.loading = true;
      let startTime = "";
      let endTime = "";
      if (this.timeTwo.length > 0) {
        startTime = this.farmatDate(
          new Date(this.timeTwo[0].toString()).getTime(),
          "-"
        );
        endTime = this.farmatDate(
          new Date(this.timeTwo[1].toString()).getTime(),
          "-"
        );
      }
      acceptListPage({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        value: this.valueName,
        organizationId:this.organizationId,
        startTime,
        endTime,
      }).then((res) => {
        if (res.code == 0) {
          this.dataSource = JSON.parse(JSON.stringify(res.data.records));
          this.pagination.current = res.data.current;
          this.pagination.total = res.data.total;
          this.height = 0;
          if (this.pagination.total > 0) {
            var box = document.getElementById("box");
            if (box.clientWidth - 250 - 5 < 1000) {
              this.height = document.documentElement.clientHeight - 500;
            } else {
              this.height = document.documentElement.clientHeight - 480;
            }
            window.onresize = () => {
              return (() => {
                this.heightLeft = `${
                  document.documentElement.clientHeight - 200
                }`;
                var left = document.getElementById("left");
                var box = document.getElementById("box");
                var right = document.getElementById("right");
                var pagination = document.getElementById("pagination");
                left.style.width = 250 + "px";
                right.style.width = box.clientWidth - 250 - 5 + "px";
                if (box.clientWidth - 250 - 5 < 1000) {
                  this.height = document.documentElement.clientHeight - 500;
                  document.getElementsByClassName(
                    "ant-pagination"
                  )[0].style.marginRight = 0;
                  document.getElementsByClassName(
                    "ant-pagination-options"
                  )[0].style.display = "none";
                } else {
                  this.height = document.documentElement.clientHeight - 480;
                  document.getElementsByClassName(
                    "ant-pagination"
                  )[0].style.marginRight = "124px";
                  document.getElementsByClassName(
                    "ant-pagination-options"
                  )[0].style.display = "block";
                }
                pagination.style.width = box.clientWidth - 250 + 5 + "px";
              })();
            };
          }
          this.loading = false;
        }
      });
    },
    getThreeList() {
      const _this = this;
      this.treeLoading = true;
      tree({
        columnName: this.value,
        siteId: sessionStorage.getItem("siteId"),
        orgIds: JSON.parse(sessionStorage.getItem("userInfo")).organizationId,
      }).then((res) => {
        if (res.code == 0) {
          this.resData = res.data;
          let options = JSON.stringify(res.data)
            .replace(/organizationName/g, "title")
            .replace(/id/g, "key");
          _this.treeData = JSON.parse(options);
          _this.oldThreeData = _this.treeData;
          _this.organizationId = _this.treeData[0].key;
          _this.checkedKeys = [_this.treeData[0].key];
          _this.expandedKeys  = [_this.treeData[0].key];
          _this.organizationName = _this.treeData[0].title;
          this.treeLoading = false;
           this.getList();
        }
      });
    },
    onSelect(key, event) {
        if(key.length == 0){
            return;
        }
        this.organizationId = key[0];
        this.organizationName = event.node._props.title;
        this.checkedKeys = [this.organizationId];
        this.getList();
    },
     chaKan(item){
      this.itemData = item;
      this.visibleAddTips = true;
    },
    noAdoption(item){
      this.dialogVisibleTwo = true;
      this.isMore = true;
      this.itemData = item;
    }
  },
};
</script>

<style lang="less" scoped>
.box {
  display: flex;
  height: 100%;
  width: 100%;
  //position: relative;
  .left {
    width: 250px;
    font-size: 14px;
    border-right: solid 1px #f2f3f5;
    color: #000;
    padding: 24px;
    padding-top: 0px;
    .title {
      margin-bottom: 24px;
    }
    .search {
      margin-bottom: 12px;
    }
    /deep/ .ant-btn-primary {
      background: #1890ff;
      padding: 0 5px;
    }
    .ant-tree {
      min-height: 300px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #415058;
    }
    /deep/ .ant-input {
      background: #f7f7f7;
    }
    /deep/ .ant-btn-primary {
      color: #fff !important;
      background-color: #1890ff !important;
    }
  }
  .right {
    flex: 1;
    height: 100%;
    width: 100%;
    font-size: 14px;
    color: #000;
    width: 500px;
    .right-name {
      padding-left: 24px;
    }
    .search {
      display: flex;
      margin-left: 24px;
      margin-right: 106px;
      margin-bottom: 20px;
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
    }
  }
}
.close-name {
  color: #303133;
  font-weight: 400;
  margin-top: 4px;
}
.close-img {
  margin-top: -1px;
  margin-right: 4px;
  cursor: pointer;
}
.right-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  margin-left: 17px;
  flex-wrap: wrap;
  .search {
    margin-left: 6px !important;
  }
  /deep/ .ant-btn,
  .ant-dropdown-trigger {
    height: 40px;
    background: #ecf5ff;
    color: #18abff;
    border-color: #c9e3ff;
    text-align: center;
  }
  /deep/ .ant-dropdown-menu-item {
    text-align: center;
  }
  /deep/ .ant-dropdown-trigger {
    border-radius: 3px;
    background-color: rgba(240, 246, 255, 1) !important;
    text-align: center;
    border: 1px solid rgba(23, 109, 230, 1) !important;
    color: rgba(23, 109, 230, 1) !important;
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
  }
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
  width: 300px;
}

.table-th {
  width: 126px;
  height: 24px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Microsoft Yahei;
  text-align: center;
  line-height: 24px;
}
.table-tn {
  width: 60px;
  height: 24px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Microsoft Yahei;
  text-align: center;
  line-height: 24px;
}
.table_one {
  border: solid 1px #ccc;
  width: 100%;
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 101px;
  border-radius: 5px;
}
.sort-box {
  width: 28px;
  height: 28px;
  background: #f5f7fa;
  text-align: center;
  line-height: 28px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .ant-btn {
    border: none;
    width: 100%;
    height: 100%;
    background: none;
  }
}
.sort-box-two {
  width: 28px;
  height: 28px;
  background: #f5f7fa;
  text-align: center;
  line-height: 28px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .ant-btn {
    border: none;
    width: 100%;
    height: 100%;
    background: none;
  }
}
.sort-two {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500 !important;
  cursor: pointer;
}
.sort-style {
  width: 43px;
  border: none;
  outline: none;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  flex: 1;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 58px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  justify-content: right;
  border-top: solid #f4f4f6 1px;
  position: absolute;
  bottom: 0;
  width: calc(100% - 529px);
  padding-right: 24px;
  bottom: 0px;
  margin-left: -5px;
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
.zhi-ding {
  width: 40px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(237, 109, 103, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(237, 109, 103, 0.3);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}
/deep/ .ant-spin-nested-loading {
  width: 100%;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 66px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 66px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-button--primary {
  background: #176de6;
}
.tui-song {
  width: 40px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(24, 109, 230, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(24, 109, 230, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}

.icon-box-img {
  cursor: pointer;
}
#resize {
  width: 5px;
  height: 100%;
  cursor: w-resize;
  float: left;
}
.right-title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 24px;
  cursor: pointer;
  .right-title-box-txt {
    color: rgba(102, 111, 128, 1);
    font-size: 14px;
    text-align: right;
    font-family: Roboto-regular;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 70%;
  }
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 20px;
}
.column-box {
  .tree-box {
    height: 406px;
    overflow-y: auto;
    background: #f8f9fa;
  }
  /deep/.el-dialog__footer {
    padding-top: -5px;
    padding-bottom: 20px;
  }
  /deep/ .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 13px;
  }
  /deep/ .el-dialog__title {
    color: rgba(48, 49, 51, 1);
    font-size: 18px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-bold;
    font-weight: 600;
  }
  /deep/ .el-dialog__close {
    font-weight: 600;
  }
}
.choose-column-box {
  /deep/ .el-select {
    width: 100%;
  }
}
/deep/ .table {
  margin-top: 0px;
}
.search-box {
  position: absolute;
  right: 24px;
}
/deep/ .ant-tree.ant-tree-show-line li:not(:last-child)::before {
  border-left: 1px dashed rgba(187, 187, 187, 1);
}
.title-box {
  overflow: hidden; 
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration:underline;
  cursor: pointer;
  color: rgba(24, 109, 230, 1);
  }
  .tips-box{
    /deep/ .el-dialog__title{
        color: rgba(48, 49, 51, 1);
        font-size: 18px;
        font-family: Roboto-black;
        font-weight: bold;
      }
      /deep/ .el-dialog__body{
        padding: 10px 20px;
      }
  }
  .title-adoptin {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  margin-bottom: 16px;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
  .score-box{
  max-height: 256px;
  min-height: 100px;
  margin-top: 14px !important;
  overflow-y: auto;
  border-radius: 4px;
  text-align: left;
  border: 1px solid rgba(220, 223, 230, 1);
  margin-top: -10px;
  padding: 8px;
  padding-top: 0px;
  display: flex;
  justify-content: space-between;
	flex-wrap: wrap;
  /deep/ .el-checkbox__label{
    display: block;
    width: 100%;
    padding-left: 4px;
  }
  /deep/ .el-checkbox__input{
    margin-top: 3px;
  }
  .item {
    width: 42%;
    margin-top: 6px;
    display: flex;
    align-items: center;
    .item-txt{
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;
        width: 100%;
    }

}
}
/deep/ .el-checkbox:last-of-type{
  margin-right: 30px;
}
</style>